import React, { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Navbar from '../components/Navbar';
import HomeMobileNavbar from '../components/HomeMobileNavbar';
import Blog from '../components/Blog';
import HomeAbout from '../components/Homeabout';
import second from '../components/assets/2.png';
import third from '../components/assets/3.png';
import fourth from '../components/assets/4.png';
import fifth from '../components/assets/5.png';
import sixth from '../components/assets/6.png';
import seventh from '../components/assets/7.png';
import eighth from '../components/assets/8.png';
import ninth from '../components/assets/9.png';
import tenth from '../components/assets/10.png';
import eleventh from '../components/assets/11.png';

gsap.registerPlugin(ScrollTrigger);

const ASTERISK_PATHS = [
  'M277.993 146.439L272.778 145.046L267.415 144.623L262.517 142.449L257.492 140.654L252.763 138.205L247.633 136.622L242.819 134.384L237.921 132.251L233.381 129.338L228.272 127.733L223.268 126.192L218.708 123.574L213.915 121.589L209.123 119.584L204.246 117.81L199.411 115.868L194.66 113.756L189.572 112.49L184.611 110.843L180.05 108.225L175.047 106.768L170.148 104.952L165.335 103.031L160.648 100.709L155.623 99.2308L151.083 96.5917L145.995 95.2616L141.118 93.4458L136.389 91.2501L131.681 88.9699L126.529 87.8509L121.927 85.2963L116.796 84.0506L112.088 81.7493L107.19 79.3002L101.912 77.7168L96.95 75.4155L91.8829 73.3253L86.9425 71.024L81.9388 68.8282L76.6606 67.3926L71.5302 65.5346L66.1253 64.9435L60.7626 64.479L55.421 65.0913L50.544 66.2103L46.2158 68.7649L42.0144 71.5729L38.4041 75.1621L35.0049 78.9202L31.6691 82.805L29.0933 87.1964L26.3486 91.4824L24.3007 96.1483L21.8093 100.73L18.7058 104.995L16.6578 109.829L14.3354 114.516L12.0974 119.246L10.1973 124.123L8.95161 129.232L7.32592 134.194L5.4891 139.113L3.67339 144.117L2.61775 149.374L1.18208 154.504L-0.000244141 159.719L0.10532 165.082L0.126433 170.402L1.0554 175.638L1.2243 181.022L2.61775 186.195L4.85571 190.839L8.50824 194.408L12.3719 197.807L16.8689 200.298L21.8093 201.755L26.4753 203.824L31.3524 205.365L36.1239 207.265L41.2332 207.899L46.1525 209.398L51.2196 210.116L56.0333 212.142L61.1215 212.839L66.273 213.261L71.3401 215.077L76.5761 216.154L81.791 217.357L87.027 218.434L92.2419 219.722L97.5412 220.545L102.651 221.939L107.886 222.741L113.122 223.586L118.253 224.937L123.278 226.647L128.429 227.85L133.18 230.278L138.437 231.418L142.997 234.163L147.515 236.992L150.809 241.173L154.377 245.142L155.327 250.462L156.488 255.614L156.573 260.934L154.884 266.001L153.659 271.195L151.675 276.157L148.972 280.759L145.847 285.108L143.039 289.648L139.894 293.997L136.494 298.114L132.42 301.64L128.809 305.567L125.22 309.494L121.884 313.4L118.57 317.348L115.107 321.106L111.539 324.801L107.971 328.516L104.445 332.253L101.046 336.012L97.1612 339.326L94.2687 343.57L90.4262 346.906L86.9848 350.622L83.67 354.464L79.8908 357.863L77.2306 362.234L73.4725 365.738L71.0023 370.193L69.2711 374.944L67.4976 379.715L67.2865 385.183L68.9544 390.356L70.4323 395.486L72.5224 400.448L75.5416 404.924L79.0886 408.999L82.7411 412.968L85.7602 417.486L89.6239 421.265L93.4242 425.15L97.0978 429.162L101.257 432.687L105.142 436.53L109.723 439.507L114.157 442.695L118.696 445.693L123.003 449.071L127.268 452.533L132.462 454.413L136.516 457.875L141.435 459.839L145.995 462.393L150.682 464.737L155.77 466.003L160.838 467.397L166.052 466.764L171.141 466.13L175.638 463.618L180.093 461.232L184.21 458.192L187.799 454.581L190.881 450.549L194.449 446.875L196.856 442.378L199.474 438.029L201.923 433.595L205.238 429.668L207.898 425.361L209.777 420.569L213.113 416.684L215.351 412.229L218.307 408.218L220.819 403.974L222.762 399.329L225.992 395.486L228.399 391.137L231.08 386.957L233.74 382.755L236.422 378.068L239.082 373.339L242.375 369.053L245.901 364.936L249.195 360.65L252.299 356.238L255.36 351.762L259.414 348.13L263.024 344.119L266.592 340.002L270.92 336.708L275.692 334.027L280.97 333.372L286.164 332.38L291.294 333.71L295.918 336.159L300.584 338.566L304.68 341.923L307.825 346.188L311.267 350.178L313.294 355.14L316.883 359.088L319.247 363.796L322.119 368.209L324.019 373.17L326.785 377.625L329.382 382.164L332.464 386.83L335.23 391.707L337.953 396.627L341.015 401.314L344.688 405.621L347.243 410.624L350.6 415.121L353.387 419.618L356.322 424.031L358.792 428.718L360.861 433.637L363.69 438.113L366.667 442.484L370.298 446.39L372.895 451.034L376.358 455.046L380.074 458.846L384.507 461.823L389.638 463.132L394.789 464.673L400.173 464.884L405.557 464.483L410.603 462.52L415.67 460.894L420.927 459.458L425.656 456.904L430.407 454.391L435.094 451.858L439.443 448.754L443.497 445.271L448.141 442.631L452.026 438.958L456.734 436.34L460.387 432.413L465.116 429.753L469.022 426.121L472.675 422.279L476.58 418.605L480.17 414.636L483.189 410.16L486.905 406.275L489.713 401.694L492.542 397.154L493.956 392.066L495.054 387.062L494.759 381.953L494.484 376.759L492.732 371.882L490.283 367.343L487.01 363.374L484.603 358.75L480.719 355.33L477.446 351.361L473.688 347.856L469.867 344.436L466.214 340.825L462.498 337.278L459.542 333.035L456.017 328.77L452.364 324.632L448.268 320.874L444.89 316.482L441.238 312.323L437.078 308.607L433.51 304.553L430.576 299.993L426.775 296.108L423.27 291.991L420.653 287.199L417.232 283.018L414.509 278.331L412.144 273.475L409.399 268.852L406.76 264.143L404.332 259.266L403.34 253.946L403.319 248.689L404.396 243.601L406.676 238.892L410.202 234.986L414.298 231.63L419.132 229.455L423.904 227.238L428.865 225.422L433.954 223.987L439.147 223.015L444.214 221.538L449.282 220.039L454.475 219.067L459.606 217.864L464.736 216.745L469.845 215.922L474.638 213.916L479.663 212.797L484.646 211.488L489.628 210.137L494.611 208.785L499.741 207.962L504.386 205.787L509.305 204.69L514.246 203.655L518.996 201.86L523.894 200.657L528.835 199.622L533.501 197.68L538.399 196.519L542.938 194.344L547.794 192.74L551.679 189.467L555.69 186.469L559.406 182.584L561.771 177.75L562.911 172.492L563.692 167.172L563.017 161.83L562.742 156.447L561.919 151.126L560.758 145.911L559.575 141.055L558.583 136.136L556.915 131.407L555.69 126.551L553.685 121.927L551.953 117.24L550.433 112.469L549.251 107.549L546.654 103.221L544.353 98.703L542.474 93.9948L540.151 89.4766L537.808 84.9796L535.359 80.5037L532.107 76.5556L527.969 73.6209L523.451 71.214L518.299 70.7917L513.401 69.6094L508.334 68.8916L503.352 70.2217L498.242 70.4117L493.281 71.5096L488.404 72.9664L483.759 75.0143L478.903 76.4922L474.216 78.4135L469.719 80.8415L464.968 82.5727L460.324 84.6629L455.066 85.7819L450.147 87.8298L444.953 89.2022L440.013 91.2501L434.967 92.9603L429.773 94.2481L425.002 96.8028L419.914 98.4285L414.656 99.5686L409.758 101.722L404.776 103.664L399.751 105.459L394.578 106.853L389.659 108.985L384.338 110.041L379.292 111.793L374.415 114.052L369.517 116.227L364.492 117.979L359.277 119.33L354.21 121.019L349.544 123.827L344.245 124.946L339.305 126.994L334.428 129.148L329.382 131.196L324.42 133.476L319.944 136.748L314.835 138.67L309.873 140.886L304.806 142.913L299.718 144.919L294.271 145.531L288.866 145.954L283.44 146.27L277.993 146.439Z',
  'M349.924 4.9193L352.627 9.22632L353.197 14.3567L353.112 19.5294L352.247 24.6387L350.938 29.6425L349.671 34.6673L348.193 39.6288L346.525 44.5481L344.667 49.383L342.894 54.2389L340.804 58.9682L338.566 63.5919L336.074 68.089L333.287 72.4382L330.163 76.5552L326.742 80.4189L323.174 84.1348L319.585 87.8295L315.447 90.9331L311.246 93.9311L306.833 96.5702L302.167 98.766L297.353 100.561L292.413 102.123L287.304 102.82L282.152 103.094L277.022 102.862L271.934 102.207L266.972 100.835L262.158 99.0827L257.492 96.9925L253.08 94.3745L248.73 91.6509L244.719 88.4629L240.919 85.0004L237.498 81.179L234.057 77.3786L230.953 73.2827L227.955 69.1446L225.422 64.6898L223.078 60.1294L221.094 55.379L219.32 50.5231L217.589 45.646L216.006 40.7267L214.718 35.723L213.662 30.677L212.733 25.5888L212.184 20.4584L212.205 15.2857L212.712 10.1553L214.654 5.36267L218.814 2.11129L223.881 0.570047L229.18 0.126677L234.479 0L239.779 0.232241L245.078 0.29558L250.356 0.73895L255.677 0.88674L260.976 1.22455L266.275 1.33011L271.596 1.58346L276.853 1.39345L282.131 1.43567L287.409 1.54124L292.687 1.52013L297.966 1.309L303.223 1.22455L308.501 0.907853H313.758L319.036 0.717837L324.293 0.612273L329.572 0.802289L334.829 0.865627L340.044 1.60458L345.153 2.7869L349.924 4.9193Z',
];

const Asterisk = ({ className = '', color = '#1e6dff' }) => (
  <svg
    viewBox="0 0 564 468"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block align-middle ${className}`}
    aria-hidden="true"
  >
    {ASTERISK_PATHS.map((d, i) => (
      <path key={i} d={d} fill={color} />
    ))}
  </svg>
);

const InlineAst = () => (
  <Asterisk className="h-[0.32em] w-[0.32em] -translate-y-[0.25em] mx-[0.05em]" />
);

const WORD_ANNOTATIONS = {
  homegrown: {
    label: '* and always growing from home',
    text: "Nufab began without a business plan or a five-year vision. It began with an instinct. We knew we wanted to make meaningful things, not just through appearance but through story, craft, and intention. Today, we're still guided by that instinct. We just have more fabric.",
  },
  preserve: {
    label: '* and evolve',
    text: "We believe culture is best preserved through use, not storage. Tradition does not belong under glass, waiting to be admired from a distance. It belongs in wardrobes, homes, conversations, and rituals. To preserve something is not to freeze it in time. It is to allow it to grow with the people who inherit it.",
  },
  sustainably: {
    label: "* it's a journey we're on",
    text: "We don't think sustainability is a destination you arrive at. It is a thousand small decisions made repeatedly. We make to-order garments, work with natural fabrics, pay our craftspeople fairly, and try to waste as little as possible. We know there is still a long road ahead, and we're committed to walking it.",
  },
  people: {
    label: '* because culture cannot be separated from its roots',
    text: "Culture does not belong to brands to be sold to people. It comes from the people, they shape it every day. It lives in homes, streets, train stations, markets, kitchens, and neighbourhood tailors. If culture is to survive, it must remain accessible and connected to the people who created it.",
  },
  everyday: {
    label: "* culture shouldn't be saved for occasion",
    text: "We make everyday clothes for people who like dressing up everyday. We believe culture is strongest when it is ordinary. Not saved for festivals, functions, or special occasions, but woven into daily life. The everyday is where identity is formed, expressed, and passed on.",
  },
};

const HoverWord = ({ active = false, onEnter, onLeave, tooltipId, children }) => {
  const data = tooltipId ? WORD_ANNOTATIONS[tooltipId] : null;
  return (
    <span className="relative inline-block" onMouseEnter={onEnter} onMouseLeave={onLeave}>
      <span className={`transition-colors duration-200 cursor-default ${active ? 'text-[#1e6dff]' : ''}`}>
        {children}
      </span>
      {data && (
        <span
          className="absolute left-0 top-full z-50 block pointer-events-none overflow-hidden"
          style={{
            width: '100%',
            maxHeight: active ? '320px' : '0px',
            opacity: active ? 1 : 0,
            transition: 'max-height 0.3s ease-in-out, opacity 0.2s ease-in-out',
            letterSpacing: 'normal',
            lineHeight: '1.5',
            fontWeight: 'normal',
          }}
        >
          <span className="font-bdogrotesk text-base font-medium block pt-3">{data.label}</span>
          <span className="text-sm md:text-base leading-snug text-black block mt-2" style={{ fontFamily: "'Courier Prime', monospace", textAlign: 'justify', textAlignLast: 'left' }}>{data.text}</span>
        </span>
      )}
    </span>
  );
};

const FALLBACK_IMG = '/images/about/milestone-2022.png';

// pct = months-from-Mar-2023 / 38 * 100 (Mar 2023 → May 2026 = 38 months)
const MILESTONES = [
  { year: "Mar '23", date: 'MARCH 2023',    pct:  0.0, image: second, text: "Nufab begins accidentally. We start getting tote bags made through Jwala, a women's NGO in Indore. Around the same time, we begin working with local artists to hand-paint them. The goal is simple: support people making things with their hands." },
  { year: "Feb '24", date: 'FEBRUARY 2024', pct: 28.9, image: third, text: "We create our first Instagram page, which is mostly pictures of painted tote bags and a lot of optimism." },
  { year: "Mar '24", date: 'MARCH 2024',    pct: 31.6, image: fourth, text: "We start selling our messenger and tote bags on Amazon. Surprisingly, some people buy them. They're still there, by the way." },
  { year: "Jul '24", date: 'JULY 2024',     pct: 42.1, image: FALLBACK_IMG, text: 'A pattern starts emerging. Everywhere we go, people ask us: "Where did you buy that?" Years of getting clothes made by local tailors slowly convince us that clothing might be worth exploring.' },
  { year: "Jan '25", date: 'JANUARY 2025',  pct: 57.9, image: fifth, text: "After many trials, experiments, and ill-fitted clothes, the search for the right master-ji leads us to Deepak Bhaiya. We set up a small machine at home and begin producing the first versions of our pieces." },
  { year: "Jun '25", date: 'JUNE 2025',     pct: 71.1, image: sixth, text: "We travel to Jaipur. For the first time, we source fabrics directly and meet some of the hands behind them. We go everywhere from block manufacturers to textile karkhaanas." },
  { year: "Jul '25", date: 'JULY 2025',     pct: 73.7, image: eighth, text: "Nufab finally starts looking like Nufab. We develop our visual identity, logo, website language, and launch a fresh Instagram page that feels more aligned with who we're becoming." },
  { year: "Aug '25", date: 'AUGUST 2025',   pct: 76.3, image: eighth, text: "Our first website goes live. It's mostly a blog. It's slightly chaotic. We love it anyway. For the first time, Nufab has a home on the internet." },
  { year: "Sep '25", date: 'SEPTEMBER 2025',pct: 78.9, image: seventh, text: "Our first photoshoot. After months of prototyping, revising, and overthinking, the first complete collection of 45 pieces is photographed. Seeing everything together feels strangely real." },
  { year: "Nov '25", date: 'NOVEMBER 2025', pct: 84.2, image: ninth, text: "We open a small pop-up store in Indore. Part office, part studio, part meeting place. The first physical corner of the world we can call ours." },
  { year: "Dec '25", date: 'DECEMBER 2025', pct: 86.8, image: tenth, text: "We participate in our first exhibitions. We spend less time selling and more time listening. People try things on, ask questions, offer criticism, and help us understand what works and what doesn't." },
  { year: "Feb '26", date: 'FEBRUARY 2026', pct: 92.1, image: FALLBACK_IMG, text: "Project 1 is officially announced — to make everyday clothes for people who like dressing up everyday. After years of conversations, experiments, and fabric samples, Nufab's first official project finally has a name." },
  { year: "May '26", date: 'MAY 2026',      pct:100.0, image: eleventh, text: "The website launches. Not the blog. Not the prototype. The actual thing that we spent months perfecting. For the first time, people can browse, read, and buy from Nufab. The beginning feels a lot like the beginning." },
];

// Pre-computed set of label indices that are >= 5.5 pct apart (avoids crowding in 2025 cluster).
// Active milestone is always shown regardless.
const VISIBLE_LABEL_INDICES = (() => {
  const result = new Set();
  let lastPct = -100;
  MILESTONES.forEach((m, i) => {
    if (m.pct - lastPct >= 5.5) { result.add(i); lastPct = m.pct; }
  });
  return result;
})();

// Starting (stacked-fan) positions for the 5 cards — small offsets in px so they sit fanned at center.
// 3 cards animate LEFT (indices 0,1,2), 2 cards animate RIGHT (indices 3,4).
// `order` is the position from the centre (0 = closest to centre when split).
const CARDS = [
  { src: '/images/about/solitaire2.webp', startX: -75, startY: 14, startRot: -22, side: 'left',  order: 2 },
  { src: '/images/about/solitaire3.webp', startX: -64, startY: 2,  startRot: -10, side: 'left',  order: 1 },
  { src: '/images/about/solitaire4.webp', startX: -4,  startY: -6, startRot: 2,   side: 'left',  order: 0 },
  { src: '/images/about/solitaire5.webp', startX: 28,  startY: 4,  startRot: 12,  side: 'right', order: 0 },
  { src: '/images/about/solitaire1.webp', startX: 56,  startY: 16, startRot: 42,  side: 'right', order: 1 },
];

const About = () => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [activeMilestone, setActiveMilestone] = useState(0);
  const [hoveredWord, setHoveredWord] = useState(null);
  const [showNav, setShowNav] = useState(false);

  const heroRef = useRef(null);
  const shubhRef = useRef(null);
  const labhRef = useRef(null);
  const logoBlockRef = useRef(null);
  const cardRefs = useRef([]);

  const touchStartXRef = useRef(null);
  const dragStartXRef = useRef(null);
  const dragMovedRef = useRef(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      setShowNav(heroRef.current.getBoundingClientRect().bottom <= 0);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isMobile = windowWidth < 768;

  useLayoutEffect(() => {
    if (!heroRef.current) return undefined;

    const ctx = gsap.context(() => {
      // Initial state: cards stacked center, logo hidden, side labels visible from the start.
      gsap.set([shubhRef.current, labhRef.current], { opacity: 1, x: 0 });
      gsap.set(logoBlockRef.current, { opacity: 0, y: 1, scale: 0.96 });

      // Initial positions for each card (stacked-fan near the centre).
      // xPercent/yPercent: -50 anchors the card's CENTRE on the top-1/2/left-1/2 point —
      // this is what truly centres them. -30 was leaving them hanging low.
      cardRefs.current.forEach((el, i) => {
        if (!el) return;
        const c = CARDS[i];
        gsap.set(el, {
          xPercent: -50,
          yPercent: -50,
          x: c.startX,
          y: c.startY,
          rotation: c.startRot,
        });
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: heroRef.current,
          start: 'top top',
          end: '+=180%', // longer pin distance — user scrolls more to complete the reveal (slower)
          pin: true,
          scrub: 1.5,    // smoother scrubbing (catches up over ~1.5s)
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      });

      // Phase 1: cards split — 3 cards stacked at FAR LEFT, 2 cards stacked at FAR RIGHT.
      // Outer-most card lands flush with the viewport edge (slightly past, so the edge is clipped).
      cardRefs.current.forEach((el, i) => {
        if (!el) return;
        const c = CARDS[i];
        // Push hard to the very edge — outermost card past 50vw so it sits flush with the viewport boundary.
        // Inner cards fan inward in 6vw steps and overlap.
        // Both sides' outermost card lands at ±46vw (flush with viewport edge).
        // Left has 3 cards → spread 34/40/46vw (step 6). Right has 2 cards → spread 34/46vw (step 12).
        const sign = c.side === 'left' ? -1 : 1;
        const maxOrderOnSide = c.side === 'left' ? 2 : 1;
        const step = maxOrderOnSide > 0 ? (46 - 34) / maxOrderOnSide : 0;
        const targetX = sign * (34 + c.order * step);

        // Rotation:
        //  - Left side fans counter-clockwise with progressively more tilt outward.
        //  - Right side: inner card tilted, OUTERMOST is vertically straight (per design).
        let targetRot;
        if (c.side === 'left') {
          // -8, -20, -32 (matches reference image fan)
          targetRot = -8 - c.order * 12;
        } else {
          // inner card: tilted; outer card: straight
          targetRot = c.order === 1 ? 0 : 10;
        }

        // Vertical fan:
        //  - Left side: front card centred, mid card lifts UP, back card drops slightly (matches image).
        //  - Right side: inner card slightly up, outer card slightly down (matches image).
        let targetY;
        if (c.side === 'left') {
          targetY = c.order === 0 ? 6 : (c.order === 1 ? -14 : 22);
        } else {
          targetY = c.order === 0 ? -10 : 14;
        }

        tl.to(el, {
          x: `${targetX}vw`,
          y: targetY,
          rotation: targetRot,
          ease: 'none',
        }, 0);
      });

      // Phase 2: logo + tagline reveal — starts immediately as cards begin to split,
      // completes by 40% of the timeline (well before cards reach the edges).
      tl.to(
        logoBlockRef.current,
        { opacity: 1, y: 0, scale: 1, ease: 'none', duration: 0.4 },
        0.2,
      );
    }, heroRef);

    const refresh = () => { try { ScrollTrigger.refresh(true); } catch (e) {} };
    const t1 = setTimeout(refresh, 100);
    const t2 = setTimeout(refresh, 400);
    const t3 = setTimeout(refresh, 900);
    window.addEventListener('load', refresh);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      window.removeEventListener('load', refresh);
      ctx.revert();
    };
  }, []);

  const goToMilestone = useCallback((i) => {
    const next = Math.max(0, Math.min(MILESTONES.length - 1, i));
    setActiveMilestone(next);
  }, []);

  // Touch swipe on the milestone row.
  const handleTouchStart = (e) => {
    touchStartXRef.current = e.touches?.[0]?.clientX ?? null;
  };
  const handleTouchEnd = (e) => {
    if (touchStartXRef.current === null) return;
    const endX = e.changedTouches?.[0]?.clientX ?? touchStartXRef.current;
    const delta = endX - touchStartXRef.current;
    if (Math.abs(delta) > 50) {
      goToMilestone(activeMilestone + (delta < 0 ? 1 : -1));
    }
    touchStartXRef.current = null;
  };

  // ---- Real drag slider ----
  // Click anywhere on the track to jump. Drag the thumb to scrub.
  // Uses window-level listeners during drag (more reliable than pointer capture).
  const trackElRef = useRef(null);
  const isDraggingSliderRef = useRef(false);
  const [isDragging, setIsDragging] = useState(false);
  const [dragPct, setDragPct] = useState(null); // null when not dragging, 0..100 while dragging

  const pctFromClientX = useCallback((clientX) => {
    const el = trackElRef.current;
    if (!el) return 0;
    const rect = el.getBoundingClientRect();
    if (rect.width <= 0) return 0;
    const x = clientX - rect.left;
    return Math.max(0, Math.min(100, (x / rect.width) * 100));
  }, []);

  const milestoneFromPct = useCallback((pct) => {
    let closest = 0;
    let minDist = Infinity;
    MILESTONES.forEach((m, i) => {
      const dist = Math.abs(m.pct - pct);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    return closest;
  }, []);

  // Window-level move/up handlers that run while dragging.
  // Defined as stable refs so the same function instance is added/removed.
  const onWindowPointerMove = useCallback((e) => {
    if (!isDraggingSliderRef.current) return;
    const pct = pctFromClientX(e.clientX);
    setDragPct(pct);
    setActiveMilestone(milestoneFromPct(pct));
  }, [pctFromClientX, milestoneFromPct]);

  const stopDrag = useCallback(() => {
    if (!isDraggingSliderRef.current) return;
    isDraggingSliderRef.current = false;
    setIsDragging(false);
    setDragPct(null);
    window.removeEventListener('pointermove', onWindowPointerMove);
    window.removeEventListener('pointerup', stopDrag);
    window.removeEventListener('pointercancel', stopDrag);
    window.removeEventListener('blur', stopDrag);
    document.body.style.userSelect = '';
  }, [onWindowPointerMove]);

  const handleTrackPointerDown = (e) => {
    if (e.button !== undefined && e.button !== 0) return;
    // Prevent native drag / text selection that otherwise shows the red no-drop cursor.
    e.preventDefault();

    isDraggingSliderRef.current = true;
    setIsDragging(true);
    document.body.style.userSelect = 'none';

    const pct = pctFromClientX(e.clientX);
    setDragPct(pct);
    setActiveMilestone(milestoneFromPct(pct));

    window.addEventListener('pointermove', onWindowPointerMove);
    window.addEventListener('pointerup', stopDrag);
    window.addEventListener('pointercancel', stopDrag);
    window.addEventListener('blur', stopDrag);
  };

  // Clean up listeners if the component unmounts mid-drag.
  useEffect(() => () => stopDrag(), [stopDrag]);

  // Keyboard support on the thumb
  const handleThumbKey = (e) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
      e.preventDefault();
      goToMilestone(activeMilestone + 1);
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
      e.preventDefault();
      goToMilestone(activeMilestone - 1);
    } else if (e.key === 'Home') {
      e.preventDefault();
      goToMilestone(0);
    } else if (e.key === 'End') {
      e.preventDefault();
      goToMilestone(MILESTONES.length - 1);
    }
  };

  const current = MILESTONES[activeMilestone];
  const progressPct = MILESTONES[activeMilestone].pct;

  return (
    <div className="min-h-screen bg-white text-black font-bdogrotesk overflow-x-hidden">
      {/* Sticky navbar — fixed to the very top, fades in once the hero has scrolled past. */}
      <div
        className={`fixed top-0 left-0 right-0 z-[9999] transition-all duration-300 ease-in-out ${showNav ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 -translate-y-2 pointer-events-none'}`}
      >
        {isMobile ? <HomeMobileNavbar /> : <Navbar />}
      </div>

      {/* HERO (pinned during scroll reveal) */}
      <section
        ref={heroRef}
        className="relative pt-6 md:pt-8 pb-6 md:pb-8 min-h-screen flex flex-col"
      >
        {/* Navbar overlaid at the absolute top of the hero */}
        <div className="absolute top-0 left-0 right-0 z-20">
          {isMobile ? <HomeMobileNavbar /> : <Navbar />}
        </div>

        {/* <p className="mt-20 md:mt-24 lg:mt-28 px-2 md:px-4 text-base md:text-base font-bdogrotesk font-medium tracking-[0.12em] uppercase">About us</p> */}

        <div className="relative mt-3 md:mt-4 px-2 md:px-4 flex-1 flex items-center">
          {/* Shubh (left) */}
          <img
            ref={shubhRef}
            src="/images/about/shubh.svg"
            alt=""
            aria-hidden="true"
            className="absolute left-0 top-1/2 -translate-y-1/2 h-6 md:h-9 w-auto select-none pointer-events-none"
          />

          {/* Labh (right) */}
          <img
            ref={labhRef}
            src="/images/about/labh.svg"
            alt=""
            aria-hidden="true"
            className="absolute right-0 top-1/2 -translate-y-1/2 h-6 md:h-9 w-auto select-none pointer-events-none"
          />

          {/* Center: stacked cards + (fading-in) logo block */}
          <div className="w-full flex justify-center">
            <div className="relative w-full max-w-[1400px] h-[380px] md:h-[460px] lg:h-[520px] flex items-center justify-center">
              {/* Cards layer — GSAP centres them via xPercent/yPercent: -50 and animates outward. */}
              {CARDS.map((c, i) => (
                <img
                  key={c.src}
                  ref={(el) => { cardRefs.current[i] = el; }}
                  src={c.src}
                  alt=""
                  aria-hidden="true"
                  className="absolute top-1/2 left-1/2 w-[190px] md:w-[260px] lg:w-[320px] h-auto pointer-events-none select-none will-change-transform"
                  style={{ zIndex: 10 + i }}
                />
              ))}

              {/* Logo + tagline — hidden initially (behind the stacked cards), fades in on scroll */}
              <div
                ref={logoBlockRef}
                className="relative z-30 pointer-events-none flex flex-col items-center text-center"
              >
                <img src="/nufab_black.png" alt="Nufab" className="h-16 md:h-24 lg:h-28 w-auto" />
                <p
                  className="mt-4 md:mt-5 max-w-[44vw] md:max-w-[18rem] lg:max-w-[21rem] text-sm md:text-base lg:text-lg leading-snug text-black"
                  style={{ fontFamily: "'Courier Prime', monospace" }}
                >
                  Hi! Behind all the curated visuals and brand philosophy, we&apos;re simply human. So are you. So, hi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HEADLINE — full width, font-bdogrotesk font-medium, home-page hero sizing */}
      <section className="px-2 md:px-4 pt-6 md:pt-10 pb-10 md:pb-14">
        <div
          role="heading"
          aria-level="1"
          className="w-full font-bdogrotesk font-medium text-5xl md:text-6xl lg:text-7xl xl:text-8xl"
          style={{ letterSpacing: '-0.028em' }}
        >
          <div className="leading-[1.0]">
            A <HoverWord active={hoveredWord === 'homegrown'} onEnter={() => setHoveredWord('homegrown')} onLeave={() => setHoveredWord(null)} tooltipId="homegrown">homegrown</HoverWord><InlineAst /> movement
            <div aria-hidden="true" className="overflow-hidden transition-all duration-300 ease-in-out" style={{ maxHeight: hoveredWord === 'homegrown' ? '235px' : '0px' }}><div className="h-[235px]" /></div>
          </div>
          <div className="leading-[1.0]">
            <HoverWord active={hoveredWord === 'preserve'} onEnter={() => setHoveredWord('preserve')} onLeave={() => setHoveredWord(null)} tooltipId="preserve">to preserve</HoverWord><InlineAst /> culture
            <div aria-hidden="true" className="overflow-hidden transition-all duration-300 ease-in-out" style={{ maxHeight: hoveredWord === 'preserve' ? '240px' : '0px' }}><div className="h-[240px]" /></div>
          </div>
          <div className="leading-[1.0]">
            and pass it on <HoverWord active={hoveredWord === 'sustainably'} onEnter={() => setHoveredWord('sustainably')} onLeave={() => setHoveredWord(null)} tooltipId="sustainably">sustainably</HoverWord><InlineAst />
            <div aria-hidden="true" className="overflow-hidden transition-all duration-300 ease-in-out" style={{ maxHeight: hoveredWord === 'sustainably' ? '265px' : '0px' }}><div className="h-[265px]" /></div>
          </div>
          <div className="leading-[1.0]">
            to <HoverWord active={hoveredWord === 'people'} onEnter={() => setHoveredWord('people')} onLeave={() => setHoveredWord(null)} tooltipId="people">The People</HoverWord><InlineAst /> in their
            <div aria-hidden="true" className="overflow-hidden transition-all duration-300 ease-in-out" style={{ maxHeight: hoveredWord === 'people' ? '265px' : '0px' }}><div className="h-[265px]" /></div>
          </div>
          <div className="leading-[1.0]">
            <HoverWord active={hoveredWord === 'everyday'} onEnter={() => setHoveredWord('everyday')} onLeave={() => setHoveredWord(null)} tooltipId="everyday">everyday</HoverWord><InlineAst /> lives.
            <div aria-hidden="true" className="overflow-hidden transition-all duration-300 ease-in-out" style={{ maxHeight: hoveredWord === 'everyday' ? '220px' : '0px' }}><div className="h-[220px]" /></div>
          </div>
        </div>
      </section>

      {/* TIMELINE / MILESTONE SLIDER */}
      <section className="px-2 md:px-4 py-14 md:py-20">
        <div
          className="flex flex-col md:flex-row md:justify-between items-stretch md:items-end gap-0 p-0 m-0 w-full"
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
        >
          <div className="w-full md:w-4/12 p-0 m-0 shrink-0">
            <div className="relative w-full aspect-[4/5]  overflow-hidden">
              {MILESTONES.map((m, i) => (
                <img
                  key={m.date}
                  src={m.image}
                  alt={m.date}
                  className="absolute inset-0 w-full h-full object-contain transition-opacity duration-300 ease-out"
                  style={{ opacity: i === activeMilestone ? 1 : 0 }}
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                />
              ))}
            </div>
          </div>

          <div className="w-full md:w-6/12 p-0 m-0 shrink-0">
            <p className="text-xl md:text-lg tracking-[0.04em] uppercase text-black/80"  style={{ fontFamily: "'Courier Prime', monospace" }}>
              {current.date}
            </p>
            <p className="mt-3 md:mt-4 text-2xl md:text-4xl lg:text-5xl leading-snug font-medium">
              {current.text}
            </p>
          </div>
        </div>

        {/* Real drag slider — rectangular track + square thumb */}
        <div className="mt-10 md:mt-14 select-none font-bdogrotesk">
          {/* Track — click anywhere to jump; drag the thumb to scrub */}
          <div
            ref={trackElRef}
            className={`relative h-[10px] md:h-[12px] bg-black/15 w-full touch-none select-none ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}`}
            onPointerDown={handleTrackPointerDown}
            onDragStart={(e) => e.preventDefault()}
            draggable={false}
          >
            {/* Fill (rectangular) */}
            <div
              className={`absolute top-0 left-0 h-full bg-[#0a2870] pointer-events-none ${isDragging ? '' : 'transition-[width] duration-500 ease-out'}`}
              style={{ width: `${dragPct != null ? dragPct : progressPct}%` }}
            />

            {/* Monthly tick marks — 39 ticks (Mar 2023 → May 2026), taller at Jan 2024/2025/2026 */}
            <div className="absolute top-full left-0 right-0 h-3 pointer-events-none">
              {Array.from({ length: 39 }, (_, i) => {
                const isYear = i === 10 || i === 22 || i === 34;
                return (
                  <div
                    key={i}
                    className={`absolute top-0 w-px ${isYear ? 'h-3 bg-black/30' : 'h-1.5 bg-black/15'}`}
                    style={{ left: `${(i / 38) * 100}%` }}
                  />
                );
              })}
            </div>

            {/* Thumb (square, draggable) */}
            <div
              role="slider"
              tabIndex={0}
              aria-valuemin={0}
              aria-valuemax={MILESTONES.length - 1}
              aria-valuenow={activeMilestone}
              aria-valuetext={current.year}
              aria-label="Timeline milestone"
              onPointerDown={handleTrackPointerDown}
              onDragStart={(e) => e.preventDefault()}
              draggable={false}
              onKeyDown={handleThumbKey}
              className={`absolute h-[22px] md:h-[26px] w-[22px] md:w-[26px] bg-[#1e6dff] focus:outline-none focus:ring-2 focus:ring-[#0a2870]/40 touch-none select-none ${isDragging ? 'cursor-grabbing' : 'cursor-grab'} ${isDragging ? '' : 'transition-[left] duration-500 ease-out'}`}
              style={{
                top: '50%',
                transform: `translate(-50%, -50%) ${isDragging ? 'scale(1.08)' : 'scale(1)'}`,
                left: `${dragPct != null ? dragPct : progressPct}%`,
              }}
            />
          </div>

          {/* Year labels — aligned with the taller tick marks at Jan of each year */}
          <div className="mt-4 relative h-5">
            {[
              { label: '2023', pct: 0 },
              { label: '2024', pct: 26.3 },
              { label: '2025', pct: 57.9 },
              { label: '2026', pct: 89.5 },
            ].map(({ label, pct }) => (
              <span
                key={label}
                className="absolute top-0 whitespace-nowrap font-bdogrotesk text-xs font-medium text-black/50"
                style={{
                  left: `${pct}%`,
                  transform: pct === 0 ? 'translateX(0%)' : pct > 85 ? 'translateX(-50%)' : 'translateX(-50%)',
                }}
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* BLOG SNIPPET (same as home) */}
      <Blog />

      {/* ABOUT SNIPPET (same as home) */}
      <HomeAbout />

    </div>
  );
};

export default About;




// import React from 'react';
// import Navbar from '../components/Navbar';
// import HomeMobileNavbar from '../components/HomeMobileNavbar';

// const About = () => {
//   const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

//   React.useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   return (
//     <div className="min-h-screen bg-[#f4f4f4] text-black font-bdogrotesk">
//       {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}

//       <section className="px-4 md:px-6 pt-16 md:pt-24 pb-10">
//         <div className="border-t border-black pt-8 md:pt-10">
//           <p className="text-xs md:text-sm tracking-[0.12em] uppercase">About Nufab</p>

//           <div className="mt-8 md:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 items-start">
//             <div className="lg:col-span-7">
//               <h1 className="text-5xl md:text-7xl leading-[0.95] font-medium max-w-[10ch]">
//                 Coming Soon
//               </h1>
//               <p className="mt-6 text-base md:text-xl leading-relaxed max-w-[42ch]">
//                 We are shaping this page with the same intention as our pieces: rooted in culture,
//                 made for the everyday. It will be live soon.
//               </p>
//             </div>

//             <div className="lg:col-span-5 border border-black p-4 md:p-6 bg-white">
//               <p className="text-xs uppercase tracking-[0.12em] text-black/70">Status</p>
//               <p className="mt-2 text-2xl md:text-3xl font-medium">In Progress</p>
//               <p className="mt-4 text-sm md:text-base leading-relaxed text-black/80">
//                 In the meantime, explore our latest drops and stories while we craft this section.
//               </p>
//               <div className="mt-6 flex items-center gap-4 text-sm md:text-base">
//                 <a href="/store" className="underline hover:opacity-70">Go to Store</a>
//                 <a href="/blogs" className="underline hover:opacity-70">Read Blogs</a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default About;